<template>

  <div>
    <div class="d-flex justify-end py-5 px-5"><log entityName="UserProfile" parentEntityName="User" :entityId="userLocal.userProfile.id" :parentEntityId="userLocal.id"/></div>
    <v-expansion-panels accordion v-model="panelOpen">
      <v-expansion-panel>
        <v-expansion-panel-header>
          Основная информация
          <div class="d-inline-block">
            <v-chip v-if="isMainFieldsValidCheck" class="position-absolute ml-2 mt-n3" small color="orange" dark>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <v-text-field @input="userLocal.lastName = $tools.capitalizeName($event)" v-model="userLocal.lastName" label="Фамилия" outlined dense hide-details="auto" ref="input1" @keydown.enter="$tools.focusNext('input2',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field @input="userLocal.firstName = $tools.capitalizeName($event)" v-model="userLocal.firstName" label="Имя" outlined dense hide-details="auto" ref="input2" @keydown.enter="$tools.focusNext('input3',$refs)"/>
            </v-col>
            <v-col cols="12">
              <v-text-field @input="userLocal.secondName = $tools.capitalizeName($event)" v-model="userLocal.secondName" label="Отчество" outlined dense hide-details="auto" ref="input3" @keydown.enter="$tools.focusNext('input4',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-select v-model="userLocal.userProfile.gender" :items="[{name:'Женщина', value:'female'},{name:'Мужчина', value:'male'}]" item-text="name" item-value="value" label="Пол" outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="6">
              <simple-date-view :date.sync="userLocal.userProfile.birth" title="Дата рождения" required ref="input4" @enterPressed="$tools.focusNext('input5',$refs)" showAge/>
            </v-col>
            <v-col cols="6">
              <phone-field :phone.sync="userLocal.phone" label="Телефон" required ref="input5" @enterPressed="$tools.focusNext('input6',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.email" label="Email" outlined dense hide-details="auto" ref="input6" @keydown.enter="$tools.focusNext('input7',$refs)"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.comment" label="Комментарий" auto-grow outlined dense hide-details="auto" ref="input7"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.commentAdd" label="Комментарий доп." auto-grow outlined dense hide-details="auto"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Дополнительные контакты
          <div class="d-inline-block">
            <!-- <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.phone1) && $tools.isEmpty(userLocal.userProfile.email) && $tools.isEmpty(userLocal.userProfile.whatsapp) && $tools.isEmpty(userLocal.userProfile.telegram) && $tools.isEmpty(userLocal.userProfile.instagram) && $tools.isEmpty(userLocal.userProfile.vk)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip> -->
                <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.phone1) && $tools.isEmpty(userLocal.userProfile.whatsapp) && $tools.isEmpty(userLocal.userProfile.telegram)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-text-field v-model="userLocal.userProfile.phone1" label="Дополнительный телефон" outlined dense hide-details="auto" ref="ac-input1" @keydown.enter="$tools.focusNext('ac-input2',$refs)"/>
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="userLocal.userProfile.phoneCompany" label="Рабочий телефон в организации" outlined dense hide-details="auto" ref="ac-input2" @keydown.enter="$tools.focusNext('ac-input3',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.whatsapp" label="Whatsapp" outlined dense hide-details="auto" ref="ac-input3" @keydown.enter="$tools.focusNext('ac-input4',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.telegram" label="Telegram" outlined dense hide-details="auto" ref="ac-input4"/>
            </v-col>
            <!-- <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.instagram" label="Instagram" outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.vk" label="Вконтакте" outlined dense hide-details="auto"/>
            </v-col> -->
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          Документ, удостоверяющий личность
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.pasSeries) || $tools.isEmpty(userLocal.userProfile.pasNumber)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="4">
              <v-text-field v-model="userLocal.userProfile.pasSeries" label="Серия" outlined dense hide-details="auto" ref="pas-input1" @keydown.enter="$tools.focusNext('pas-input2',$refs)"/>
            </v-col>
            <v-col cols="8">
              <v-text-field v-model="userLocal.userProfile.pasNumber" label="Номер" outlined dense hide-details="auto" ref="pas-input2" @keydown.enter="$tools.focusNext('pas-input3',$refs)"/>
            </v-col>
            <v-col cols="12">
              <passport-issuer-search :value.sync="userLocal.userProfile.pasBy" ref="pas-input3" @enterPressed="$tools.focusNext('pas-input4',$refs)"/>
            </v-col>
            <v-col cols="12">
              <simple-date-view :date.sync="userLocal.userProfile.pasDate" title="Дата выдачи" required ref="input4" @enterPressed="$tools.focusNext('input5',$refs)" />
            </v-col>
            <v-col cols="12" class="subtitle-2 text--secondary">Адрес регистрации</v-col>
            <v-col cols="9">
              <v-textarea v-model="userLocal.userProfile.pasAddrStreet" label="Город, улица, дом" persistent-hint auto-grow rows="1" outlined dense hide-details="auto" ref="pas-input5" @keydown.enter="$tools.focusNext('pas-input6',$refs)"/>
            </v-col>
            <v-col cols="3">
              <v-text-field v-model="userLocal.userProfile.pasAddrRoom" label="Квартира" outlined dense hide-details="auto" ref="pas-input6"/>
            </v-col>
            <v-col cols="12">
              <autocomplete-single name="Тип документа" :items="passTypes" :select.sync="userLocal.userProfile.passType" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          Адрес проживания
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.resAddrStreet)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.resAddrStreet" label="Город, улица, дом" persistent-hint auto-grow rows="1" outlined dense hide-details="auto" ref="a-input1" @keydown.enter="$tools.focusNext('a-input2',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.resAddrEntrance" label="Подьезд" outlined dense hide-details="auto" ref="a-input2" @keydown.enter="$tools.focusNext('a-input3',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.resAddrIntercom" label="Домофон" outlined dense hide-details="auto" ref="a-input3" @keydown.enter="$tools.focusNext('a-input4',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.resAddrFloor" label="Этаж" outlined dense hide-details="auto" ref="a-input4" @keydown.enter="$tools.focusNext('a-input5',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.resAddrRoom" label="Квартира / Помещение" outlined dense hide-details="auto" ref="a-input5" />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="userLocal.type==='client'">
        <v-expansion-panel-header>
          Место работы
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.workOrgName) && $tools.isEmpty(userLocal.userProfile.workOrgPhone)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.workOrgName" label="Название организации" outlined dense hide-details="auto" ref="w-input1" @keydown.enter="$tools.focusNext('w-input2',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.workOrgPhone" label="Телефон организации" outlined dense hide-details="auto" ref="w-input2"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel v-if="userLocal.type==='admin'">
        <v-expansion-panel-header>
          Номер доверенности администратора
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.POANumber)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-text-field v-model="userLocal.userProfile.POANumber" label="Номер доверенности администратора" outlined dense hide-details="auto"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          ИНН
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.inn)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <!-- <v-text-field v-model="userLocal.userProfile.inn" label="Номер" hint="12 цифр" outlined dense hide-details="auto" :rules="userLocal.type='admin'&&userLocal.userProfile.inn.length!=12 ? false : true"/> -->
              <inn-text-field :inn.sync="userLocal.userProfile.inn" required v-if="userLocal.type==='admin'"/>
              <inn-text-field :inn.sync="userLocal.userProfile.inn" v-if="userLocal.type!=='admin'"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          СНИЛС
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.snils)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-text-field v-model="userLocal.userProfile.snils" label="Номер" outlined dense hide-details="auto"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Подпись</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-badge icon="mdi-upload" color="grey" offset-x="28" offset-y="28" bordered>
            <v-btn @click="userSignatureUploadOpen=true" width="200" height="100" color="grey lighten-3" elevation="0">
              <v-icon v-if="userLocal.signatureUrl==null" size="64" color="grey">mdi-draw</v-icon>
              <v-img v-else :src="userLocal.signatureUrl" contain width="200" height="100"/>
            </v-btn>
          </v-badge>
          <uploader
              :dialog.sync="userSignatureUploadOpen"
              :multiple="false"
              :url="'/api/user/'+$router.currentRoute.params.id+'/signature/'"
              @uploadComplete="(v)=>v.length>0 ? userLocal.signatureUrl=v[0] : null"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
          Мед. карта
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.medCardNumber)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-text-field v-model="userLocal.userProfile.medCardNumber" :label="'Номер мед. карты'+($tools.isEmpty(userLocal.userProfile.medCardNumber) ? ' (по умолчанию '+user.id+')' : '')" hint="Если не указан, по умолчанию будет использоваться id пользователя"  outlined dense hide-details="auto" ref="md-input1" @keydown.enter="$tools.focusNext('md-input2',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.medCardStore" label="Склад" outlined dense hide-details="auto" ref="md-input2" @keydown.enter="$tools.focusNext('md-input3',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.medCardStorePosition" label="Расположение на складе" outlined dense hide-details="auto" ref="md-input3"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ОМС
          <div class="d-inline-block">
            <v-chip v-if="$tools.isEmpty(userLocal.userProfile.insurOms)" class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <insur-select type="oms" single  :selectedItems="userLocal.userProfile.insurOms" onlyRelevant @selected="(v)=>userLocal.userProfile.insurOms = v"/>
            </v-col>
            <v-col cols="6">
              <date-view title="Дата окончания" :date.sync="userLocal.userProfile.insurOmsEnd" dbformat/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.insurOmsDes" label="Описание" rows="2" auto-grow clearable hide-details outlined dense/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          ДМС
          <div class="d-inline-block">
            <v-chip v-if="$tools.isEmpty(userLocal.userProfile.insurDms)" class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <insur-select type="dms" single :selectedItems="userLocal.userProfile.insurDms" onlyRelevant @selected="(v)=>userLocal.userProfile.insurDms = v"/>
            </v-col>
            <v-col cols="6">
              <date-view title="Дата окончания" :date.sync="userLocal.userProfile.insurDmsEnd" dbformat/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.insurDmsDes" label="Описание" rows="2" auto-grow clearable hide-details outlined dense/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Первичный договор
          <div class="d-inline-block">
            <v-chip v-if="$tools.isEmpty(userLocal.userProfile.contractNumber) && $tools.isEmpty(userLocal.userProfile.contractDate)" class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <v-text-field
                  v-model="userLocal.userProfile.contractNumber"
                  :label="'Номер первичного договора'+($tools.isEmpty(userLocal.userProfile.contractNumber) ? ' (по умолчанию '+user.id+')' : '')"
                  hint="Если не указан, по умолчанию будет использоваться id пользователя"
                  outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="6">
              <date-view title="Дата" :date.sync="userLocal.userProfile.contractDate" dbformat/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Программы лояльности
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.promoSource)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <v-select v-model="userLocal.userProfile.promoSource" :items="promoSources" item-text="name" item-value="id" label="Рекламный источник" outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="6">
              <v-checkbox v-model="userLocal.userProfile.isLeadBonus" label="Начислять бонусы за направления" class="mt-n1" dense hide-details />
            </v-col>
            <v-col cols="6">
            <v-text-field v-model.number="userLocal.userProfile.discount" label="Личная скидка %" outlined dense hide-details="auto" :rules="[discountValidation]"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="userLocal.type!=='client'">
        <v-expansion-panel-header>
          Медицинские сертификаты
          <div class="d-inline-block">
            <v-chip
                v-if="$tools.isEmpty(userLocal.userProfile.certificateText)"
                class="position-absolute ml-2 mt-n3" small>не заполнено</v-chip>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.certificateText" label="Текст" rows="1" auto-grow outlined dense hide-details="auto"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="userLocal.type!=='client'">
        <v-expansion-panel-header>
          Описание для внешних сервисов
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.experience" label="Стаж с (год)" outlined dense hide-details="auto" v-mask="'####'" :rules="[v => v.length === 4 || 'Введите год']" ref="external-input1" @keydown.enter="$tools.focusNext('external-input2',$refs)"/>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="userLocal.userProfile.rank" label="Категория" outlined dense hide-details="auto" ref="external-input2" @keydown.enter="$tools.focusNext('external-input3',$refs)"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.jobDesc" label="Описание должности" rows="3" auto-grow outlined dense hide-details="auto" ref="external-input3"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.education" label="Образование" rows="5" auto-grow outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.work" label="Опыт работы" rows="5" auto-grow outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.professional" label="Профессиональные интересы" rows="5" auto-grow outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="userLocal.userProfile.description" label="Описание" rows="5" auto-grow outlined dense hide-details="auto"/>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Настройки пользователя системы
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12">
              <alert-view icon="mdi-information-outline" text="Только администратор может настраивать пользователя системы" />
            </v-col>
            <v-col cols="12">
              <btn-question
                  title="Сбросить пароль?"
                  @click="resetPassword()"
              >
                <template v-slot:content>
                  <div class="ma-4">Будет сгенерирован новый случайный пароль</div>
                </template>
                Сбросить пароль
              </btn-question>
            </v-col>
            <v-col cols="6">
              <v-select v-model="userLocal.type" :disabled="$store.state.user.type!=='admin'" :items="[{name:'Клиент', value:'client'},{name:'Специалист', value:'spec'},{name:'Администратор', value:'admin'}]" item-text="name" item-value="value" label="Тип" outlined dense hide-details="auto"/>
            </v-col>
            <v-col cols="6">
              <v-select
                  v-model="userLocal.status"
                  :disabled="$store.state.user.type!=='admin'"
                  :items="[{name:'Активен', value:'active'},{name:'Отключен', value:'unactive'}]"
                  item-text="name" item-value="value" label="Статус"
                  outlined dense hide-details="auto"
              />
            </v-col>
            <v-col cols="12">
              <div class="body-2 font-weight-medium mb-2">Доступ</div>
              <v-sheet rounded outlined :key="'permsSelectedKey_'+permsSelectedKey">
                <div v-for="(v,k) in permsStruct" :key="v.id">
                  <user-perm :item="v" :level="0" :permsSelected="permsSelected" :parentSelected="false"/>
                  <v-divider v-if="k<permsStruct.length-1"/>
                </div>
              </v-sheet>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import axios from "axios";
import Api from "@/Api";
import DateView from "@/components/DateView";
import InnTextField from "@/components/InnTextField";
import PhoneField from "@/components/PhoneField";
import AlertView from "@/components/AlertView.vue";
import BtnQuestion from "@/components/btnQuestion.vue";
import Uploader from "@/components/Uploader.vue";
import Log from "@/views/Log/Log";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import {Entity_PassType} from "../../../EntityStoreCacheService";
import InsurSelect from "@/views/Insur/components/InsurSelect";
import PassportIssuerSearch from "@/componentsV2/base/PassportIssuerSearch.vue";
import SimpleDateView from "@/components/SimpleDateView";
import UserPerm from "@/views/User/UserPerm.vue";


export default {
  components: {
    UserPerm,
    AutocompleteSingle,
    Uploader, 
    BtnQuestion, 
    AlertView, 
    DateView, 
    InsurSelect, 
    InnTextField, 
    PhoneField,
    Log,
    PassportIssuerSearch,
    SimpleDateView
  },
  props:['user'],
  data: () => ({
    panelOpen: [],
    promoSources: [],
    userSignatureUploadOpen:null,
    passTypes:[],
    userLocal:{
      id:null,
      firstName:null,
      lastName:null,
      secondName:null,
      phone:null,
      imageUrl:null,
      signatureUrl:null,
      type:null,
      permsPossibles: null,
      perms: null,
      userProfile: {
        id: null,
        gender: null,
        birth: null,
        phone1: null,
        POANumber: null,
        phoneCompany: null,
        email: null,
        comment:null,
        commentAdd:null,
        whatsapp: null,
        telegram: null,
        // instagram: null,
        // vk: null,
        promoSource: null,
        resAddrStreet: null,
        resAddrEntrance: null,
        resAddrIntercom: null,
        resAddrFloor: null,
        resAddrRoom: null,
        pasSeries: null,
        pasNumber: null,
        pasBy: null,
        pasDate: null,
        pasAddrStreet: null,
        pasAddrRoom: null,
        inn: null,
        snils: null,
        medCardNumber: null,
        medCardStore: null,
        insurOms: null,
        insurOmsEnd: null,
        insurOmsDes: null,
        insurDms: null,
        insurDmsEnd: null,
        insurDmsDes: null,
        contractNumber: null,
        contractDate: null,
        isLeadBonus: null,
        certificateText:null,
        discount: null,
        experience:null,
        rank:null,
        jobDesc: null,
        education: null,
        work: null,
        professional: null,
        description: null,
        passType:null,
        status:null,
      },
      userSpecs: {
        id: null,
        spec: {
          id: null,
          name: null,
        }
      }
    },
    birthDateActivePicker: false,
    permsSelectedKey:0,
    permsSelected:[],
    permsStruct:[],
  }),
  beforeMount() {
    this.panelOpen = 0;
    this.userLocal = Object.assign(this.userLocal, this.user);
    this.promoSourcesLoad();
  },
  mounted(){
    new Entity_PassType()
        .selects(Entity_PassType.id)
        .selects(Entity_PassType.name)
        .selects(Entity_PassType.code)
        .order(Entity_PassType.sort, true)
        .page(1)
        .onPage(100)
        .addStateCallback((v)=>{
          if(v.success)
            this.passTypes = v.items;
        })
        .request()

    this.permsStruct = [];
    if(!this.$tools.isEmpty(this.userLocal.permsPossibles)){
      // value → key (для определения “корневых” узлов)
      const valueToKey = {};
      for (const [key, value] of Object.entries(this.userLocal.permsPossibles)) {
        valueToKey[value.trim()] = key;
      }

      // Очистка имени (убираем "(полный доступ)")
      const cleanName = s => s.replace(/\(полный доступ\)/i, "").trim();

      // Узлы по полному пути
      const nodes = {};

      for (const [key, rawValue] of Object.entries(this.userLocal.permsPossibles)) {
        const value = rawValue.trim();
        const parts = value.split("/").map(v => cleanName(v.trim()));

        let accParts = [];
        let parentPath = null;

        for (let i = 0; i < parts.length; i++) {
          accParts.push(parts[i]);
          const fullPath = accParts.join(" / ");

          // Если это самый верхний уровень и для него есть ключ — используем его
          // Иначе id = ключ текущего значения
          let nodeId;

          if (valueToKey[fullPath]) {
            nodeId = valueToKey[fullPath];       // корневой ключ
          }
          else if (i === parts.length - 1) {
            nodeId = key;                         // leaf ключ
          }
          else {
            // Промежуточный уровень → уникальный технический ID
            nodeId = "gen_" + fullPath.toLowerCase().replace(/\W+/g, "_");
          }

          // Создаём узел если его ещё нет
          if (!nodes[fullPath]) {
            nodes[fullPath] = {
              id: nodeId,
              name: parts[i],
              childs: [],
              __path: fullPath
            };
          }

          // Привязка к родителю
          if (parentPath) {
            const parent = nodes[parentPath];
            const child = nodes[fullPath];

            if (!parent.childs.some(c => c.__path === fullPath)) {
              parent.childs.push(child);
            }
          }

          parentPath = fullPath;
        }
      }

      // Найти корни (те, что не являются чьими-либо детьми)
      const allPaths = Object.keys(nodes);
      const childPaths = new Set();
      Object.values(nodes).forEach(n => n.childs.forEach(c => childPaths.add(c.__path)));

      const roots = allPaths
          .filter(p => !childPaths.has(p))
          .map(p => nodes[p]);

      // Очистить вспомогательные поля
      const clean = node => ({
        id: node.id,
        name: node.name,
        childs: node.childs.map(clean)
      });

      this.permsStruct = roots.map(clean);
    }

    this.permsSelected = this.$tools.isEmpty(this.userLocal.perms) ?
        [] :
        this.userLocal.perms.split(',').map(v=>{return {id:v}});
  },
  computed: {
    isMainFieldsValidCheck(){
      return this.$tools.isEmpty(this.userLocal.lastName) || this.$tools.isEmpty(this.userLocal.firstName) || this.$tools.isEmpty(this.userLocal.secondName) || this.$tools.isEmpty(this.userLocal.userProfile.gender) || this.$tools.isEmpty(this.userLocal.userProfile.birth) || this.$tools.isEmpty(this.userLocal.phone);
    }
  },
  watch:{
    userLocal: {
      handler: function(val) {
        this.$emit('update:user', val);
      },
      deep: true
    },
    'userLocal.userProfile.insurOms'(v){
      if(v===null) this.userLocal.userProfile.insurOmsEnd = null;
    },
    'userLocal.userProfile.insurDms'(v){
      if(v===null) this.userLocal.userProfile.insurDmsEnd = null;
    },
    'userLocal.secondName'(newV,oldV){
        if (oldV!==null)//не меняем при первом запуске
          this.userLocal.userProfile.gender = this.$tools.getGenderBySecondName(newV);
    },
    permsSelected(){
      this.userLocal.perms = this.permsSelected.map(v=>v.id).join(',')
    }
  },
  methods:{
    promoSourcesLoad(){
      axios.get(Api.host+'/user/promoSource/')
        .then(r=> {
          this.promoSources = r.data;
        })
        .catch(e=>{
          console.log(e)
        });
    },
    resetPassword(){
      axios.put(Api.host+'/user/'+this.userLocal.id+'/resetPass/')
        .then(r=> {
          this.$store.commit('alertSuccess', 'Новый пароль: '+r.data.pass);
        })
        .catch(e=>{
          console.error(e.response.data.message)
        });
    },
    discountValidation(value) {
      const number = Number(value);
      if (isNaN(number)) {
        return "Введите цифры от 0 до 100";
      }
      if (number < 0 || number > 100) {
        return "Введите цифры от 0 до 100";
      }
      return true;
    },
  }
}
</script>